/**
 * @file
 * Generate main script file.
 *
 * This file includes all JS partials from the main subdirectory to generate
 * all necessary JS methods.
 */

//=require ./main/*.js
